import { BulkAction, Dialog, SingleAction } from "@saleor/types";
import { stringify as stringifyQs } from "qs";

export const popupSection = "/popup/";
export type PopupUrlQueryParams = BulkAction &
  Dialog<PopupUrlDialog> &
  SingleAction;
export const PopipUrl = (params?: PopupUrlQueryParams) =>
  popupSection + "?" + stringifyQs(params);
export type PopupUrlDialog = "assign-voucher";
